// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UnRestrictedVehiclesVmMapper from "../../view/vm-mapper/UnRestrictedVehiclesVmMapper.bs.js";

var initialAddress = {
  latLng: undefined,
  address1: "",
  address2: "",
  senderName: "",
  senderNumber: ""
};

function initialWaypoint(id) {
  return {
          address: initialAddress,
          id: id,
          showForm: false
        };
}

var initialState_customerInfo = {
  mobile: "",
  customerId: ""
};

var initialState_wayPointOne = {
  address: initialAddress,
  id: /* First */1,
  showForm: false
};

var initialState_wayPointTwo = {
  address: initialAddress,
  id: /* Second */2,
  showForm: false
};

var initialState_wayPointThree = {
  address: initialAddress,
  id: /* Third */3,
  showForm: false
};

var initialState_restricted_vehicles = [];

var initialState_vehicles = {
  on_demand: [],
  vehicle_ids: []
};

var initialState = {
  currentStep: /* PickupDropStep */0,
  pickupAddress: initialAddress,
  dropAddress: initialAddress,
  selectedVehicle: UnRestrictedVehiclesVmMapper.emptyVMData,
  geo_region: undefined,
  goods_type: undefined,
  customerInfo: initialState_customerInfo,
  isRebook: false,
  snackbarMessage: undefined,
  wayPointOne: initialState_wayPointOne,
  wayPointTwo: initialState_wayPointTwo,
  wayPointThree: initialState_wayPointThree,
  restricted_vehicles: initialState_restricted_vehicles,
  vehicles: initialState_vehicles,
  parentOrderId: undefined,
  selectedGoodsType: undefined
};

export {
  initialAddress ,
  initialWaypoint ,
  initialState ,
  
}
/* UnRestrictedVehiclesVmMapper Not a pure module */
